

const data = {
    letters: ["a", "b", "c", "a", "b", "c", "a", "b", "c"],
    correct:["У тебе все виходить!!!", "Все гарно - не зупиняйся!!!", "Давай давай - ще трішки!!!", "Не зупиняйся!!!"],
    wrong:["Сьогодні не твій день - але завтра...", "Братанчик - спробуй ще!!!", "Не псіхуй - спробуеш знову!!!"],
    winner:["Молодець - все гарно!!!", "Бачиш ціль - не бачиш перешкод!!!", "Прийшов, побачив,переміг!!!"]
  }


export default data